module.exports = __webpack_public_path__ + "img/b2.1ee46852.png";